import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nonexistent-page',
  templateUrl: './nonexistent-page.component.html',
  styleUrls: ['./nonexistent-page.component.scss']
})
export class NonexistentPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
